<style scoped>
.container {
  height: 60.5vh;
}

#usernameOrEmail:disabled {
  color: #000000;
  border-bottom: 1px solid #9e9e9e;
}
</style>

<template lang="pug">
.container
  .vspace.large
  .row
    p.title.large.col.s12 Request Password Reset

  v-row(v-if='resetSent')
    .col.s12
      .card.center-align
        .card-content
          p If your account is valid, instructions to reset your password has been sent to your email address.
  form.row(@submit.prevent='submit', v-else)
    v-col(cols='12', sm='12')
      // input#usernameOrEmail(type='text' v-model='usernameOrEmail' required)
      //- input#usernameOrEmail(
      //-   type='text',
      //-   v-model='usernameOrEmailTemp',
      //-   required
      //- )
      //- label(for='usernameOrEmail') Email
      v-text-field#usernameOrEmail(
        v-model='usernameOrEmailTemp',
        label='Email'
      )
    v-col.right-align(cols='12', sm='12')
      button.btn(type='submit') Reset password
</template>
<script>
export default {
  data () {
    return {
      resetSent: false,
      usernameOrEmail: this.$route.params.usernameOrEmail,
      usernameOrEmailTemp: this.$route.params.usernameOrEmail
    }
  },
  mounted () {
    this.$M.updateTextFields()
  },
  methods: {
    submit () {
      this.$http
        .post(`${this.$config.API_URL}/account/request-password-reset`, {
          usernameOrEmail: this.usernameOrEmailTemp,
          accountType: 'customer'
        })
        .then(() => {
          this.resetSent = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-request-password-reset.vue